module.exports = __webpack_public_path__ + "static/media/rubyImg.aaf7f60d.png";